import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { BestAvailableModel, ReserveRequest, ReserveResponse } from "../interfaces/types";

export type BestAvailableModelQueryParams = {
    exchangeMode: boolean;
    pageId: number;
    productionSeasonId: number;
    performanceId: number;
};

export const apiSlice = createApi({
    reducerPath: "api",
    baseQuery: fetchBaseQuery({
        baseUrl: `/api/bestAvailable/`
    }),
    endpoints(builder) {
        return {
            getBestAvailableModel: builder.query({
                query: (request: BestAvailableModelQueryParams) => `GetBestAvailableModel?pageId=${request.pageId}&productionSeasonId=${request.productionSeasonId}&performanceId=${request.performanceId}&exchangeMode=${request.exchangeMode}`,
                transformResponse: (response: BestAvailableModel) => {
                    return response;
                }
            }),
            submitReserveRequest: builder.mutation({
                query: (request: ReserveRequest) => ({
                    url: `SubmitReserveRequest`,
                    method: 'POST',
                    body: request,
                }),
                transformResponse: (response: ReserveResponse) => {
                    return response;
                }
            }),
        };
    },
});

export const { useGetBestAvailableModelQuery, useSubmitReserveRequestMutation } = apiSlice;